import Config from "services/config/config";
import callWebService, {
    callTypes
} from "services/utils/networks/network";
import {
    VALET_LISTING_PAGE,
    VALET_INCENTIVE_LIST,
    EDIT_INCENTIVE_DATA,
    LAST_FIVE_TRANSACTIONS,
    VALET_BULK_APPROVAL
} from "./type";


export const valetIncentiveListing = (user_id,from_date,to_date,project_id,page=1,penalty=false) => async (dispatch) => {
    try {
        
          let  url = `${Config.postSales.valetIncentiveData}?user_id=${user_id}&from_date=${from_date}&to_date=${to_date}&project_id=${project_id}&show_penalties=${penalty}`;

        const res = await callWebService(
            callTypes.get,
            {},
            url
        );

        if (res) {
            const { data } = res;
            dispatch({
                type: VALET_LISTING_PAGE,
                payload: data?.response?.data,
            });
            return true;
        }
    }
    catch {
        dispatch({
            type: VALET_LISTING_PAGE,
            payload: null,
        });
        return true;
    }
}

export const valetIncentiveList = (filterData = null, page = 1) => async (
    dispatch
  ) => {
    dispatch({
      type: VALET_INCENTIVE_LIST,
      payload: null,
    });
    console.log(filterData)
    const res = await callWebService(
      callTypes.get,
      '',
      `${Config.postSales.fetchIncentiveListing}?page=${page}${
        filterData !== null 
          ? `&from_date=${filterData.from_date}&to_date=${filterData.to_date}${
              filterData.user_id ? `&user_id=${filterData.user_id}` : ''
            }`
          : ''
      }`
  );
    if (res) {
      const { data } = res;
      dispatch({
        type: VALET_INCENTIVE_LIST,
        payload: data.response.data,
      });
      return true;
    }
  };


  export const editIncentiveList = (editData) => async () => {
    const res = await callWebService(
      callTypes.post,
      editData,
      Config.postSales.editIncentiveData
    );
    if (res?.data) {
      if (res?.data.status_code == 500){
        return false;
      }
      else if (res?.data?.status == false){
        return false;
      }
      else{
        return true;
      }
    } else {
      return null;
    }
  };


  export const lastFiveTransactionListing = (user_id,page=1) => async (dispatch) => {
    try {
          let  url = `${Config.postSales.lastFiveTransactionData}?user_id=${user_id}`;

        const res = await callWebService(
            callTypes.get,
            {},
            url
        );

        if (res) {
            const { data } = res;
            dispatch({
                type: LAST_FIVE_TRANSACTIONS,
                payload: data?.response?.data,
            });
            return true;
        }
    }
    catch {
        dispatch({
            type: LAST_FIVE_TRANSACTIONS,
            payload: null,
        });
        return true;
    }
}

export const valetUserBulkApprove = (from_date,to_date,selectedItems = null) => async (
  dispatch
) => {


  const payloadData={
    "start_date":from_date,
    "end_date":to_date,
    "user_project_list":selectedItems,
    "status":"OPS_APPROVED"
  };
  dispatch({
    type: VALET_BULK_APPROVAL,
    payload: null,
  });
  const res = await callWebService(
    callTypes.post,
    payloadData,
    `${Config.postSales.valetIncentiveBulkApproval}`
  );
  if (res) {
    const { data } = res;
    dispatch({
      type: VALET_BULK_APPROVAL,
      payload: data.response.data,
    });
    return true;
  }
};


